// Open Grievances by Department — open/in_progress only, grouped by department,
// count + oldest-open age per group (points at the unit/process with a backlog).
import React from "react";
import { ReportShell, Card, EmptyState } from "./_shared";
import { departmentLabel, OPEN_STATUSES, openAgeDays } from "../grievanceModel";

export default function OpenByDepartment({ records = [] }) {
  const open = records.filter((r) => OPEN_STATUSES.includes(r.status));
  const groups = {};
  open.forEach((r) => {
    const k = r.department || "other";
    if (!groups[k]) groups[k] = { count: 0, oldest: null };
    groups[k].count += 1;
    const age = openAgeDays(r);
    if (age != null && (groups[k].oldest == null || age > groups[k].oldest)) groups[k].oldest = age;
  });
  const rows = Object.entries(groups).map(([key, g]) => ({ key, ...g })).sort((a, b) => b.count - a.count);

  return (
    <ReportShell title="Open Grievances by Department" subtitle={`${open.length} open (open + in progress) grievance${open.length === 1 ? "" : "s"} grouped by department.`}>
      {rows.length === 0 ? (
        <EmptyState>No open grievances for this scope.</EmptyState>
      ) : (
        <Card style={{ padding: 0, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13.5 }}>
            <thead>
              <tr style={{ background: "var(--ed-bg)", borderBottom: "1px solid var(--ed-line)" }}>
                <th style={th}>Department</th>
                <th style={{ ...th, textAlign: "right" }}>Open Count</th>
                <th style={{ ...th, textAlign: "right" }}>Oldest Open</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const stale = r.oldest != null && r.oldest > 5;
                return (
                  <tr key={r.key} className="table-row" style={{ borderBottom: "1px solid var(--ed-line-2)" }}>
                    <td style={{ padding: "12px 16px", fontWeight: 600, color: "var(--ed-ink)" }}>{departmentLabel(r.key)}</td>
                    <td style={{ padding: "12px 16px", textAlign: "right", fontWeight: 800, fontSize: 16, color: "var(--ed-ink)" }}>{r.count}</td>
                    <td style={{ padding: "12px 16px", textAlign: "right", color: stale ? "var(--ed-alert)" : "var(--ed-ink-3)", fontWeight: stale ? 700 : 500 }}>
                      {r.oldest == null ? "—" : `${r.oldest} day${r.oldest === 1 ? "" : "s"}`}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Card>
      )}
    </ReportShell>
  );
}

const th = { textAlign: "left", padding: "10px 16px", fontSize: 11, fontWeight: 700, color: "var(--ed-muted)", textTransform: "uppercase", letterSpacing: ".04em" };
